import axios from './axiosInstance';

export default class LegislacaoApi {
    static async getLegislacoes({
        page = 1,
        categoriaId = '',
        termoBusca = '',
    }) {
        if(categoriaId == null) {
            categoriaId = '';
        }
        if(page == null) {
            page = 1;
        }

        if(termoBusca == null) {
            termoBusca = '';
        }
    
        return axios.get(`${process.env.VUE_APP_BASE_API_URL}/api/v1/legislacoes_selecionadas?page=${page}&categoria_legislacao_selecionada_id=${categoriaId}&per_page=6&termo_busca=${termoBusca}`);
    }

    static async getLegislacao(id) {
        return axios.get(`${process.env.VUE_APP_BASE_API_URL}/api/v1/legislacoes_selecionadas/${id}`);
    }
}